import { useTranslate } from '@tolgee/react';
import LeftArrow from '../../../assets/icons/left-arrow-new.svg';
import VoucherOrder from '../voucher-order/VoucherOrder';
import './VoucherCheckout.scss';

const VoucherCheckout = ({ toggleCheckoutSectionVisibility }: any) => {
  const { t } = useTranslate();
  return (
    <div className='voucher-checkout'>
      <div className='voucher-checkout-header'>
        <div className='voucher-checkout-header__container'>
          <img
            src={LeftArrow}
            alt=''
            srcSet=''
            onClick={() => toggleCheckoutSectionVisibility(false)}
          />
          <p>{t('vouchers')}</p>
        </div>
      </div>
      <VoucherOrder
        toggleCheckoutSectionVisibility={toggleCheckoutSectionVisibility}
      />
    </div>
  );
};

export default VoucherCheckout;
